const mutations = {
  SET_ORDER_ID: (state, id) => {
    state.order_id = id
  },
  SET_INSTALLMENT_DEFAULT: (state, installmentDefault) => {
    state.installment_default = installmentDefault
  },
  SET_SELECTED_INSTALLMENT: (state, selectedInstallment) => {
    state.selected_installment = selectedInstallment
  },
  SET_RECAPTCHA_ATTEMPTS: (state, recaptchaAttempts) => {
    state.recaptcha_attempts += recaptchaAttempts
  },
  SET_STORE_NAME: (state, storeName) => {
    state.store_name = storeName
  },
  SET_VISIT: (state, visit) => {
    state.visit = visit
  },
  SET_ORDER_REDIRECT: (state, redirected) => {
    state.orderBumpRedirected = redirected
  },
  SET_ENABLE_ADDRESS: (state, enableAddress) => {
    state.enable_address = enableAddress
  },
  SET_FREIGHTS: (state, freights) => {
    state.freights = freights
  },
  SET_HASH: (state, hash) => {
    state.hash = hash
  },
  SET_SHOP_URL: (state, shopUrl) => {
    state.shop_url = shopUrl
  },
  SET_SHOP_CANCEL_URL: (state, shopCancelUrl) => {
    state.shop_cancel_url = shopCancelUrl
  },
  SET_STORE_ID: (state, storeId) => {
    state.store_id = storeId
  },
  SET_DISCOUNT: (state, discount) => {
    state.discount = discount
  },
  SET_FREIGHT: (state, freight) => {
    state.freight = freight
  },
  SET_TOTAL: (state, total) => {
    state.total = total
  },
  SET_SUBTOTAL: (state, subtotal) => {
    state.subtotal = subtotal
  },
  SET_COUPON: (state, coupon) => {
    state.coupon = coupon
  },
  SET_ITEMS: (state, items) => {
    state.items = items
  },
  SET_INSTALLMENTS: (state, installments) => {
    state.installments = installments
  },
  SET_FREIGHT_ID: (state, freightId) => {
    state.freight_id = freightId
  },
  SET_CART: (state, cart) => {
    Object.assign(state, cart)
  },
  SET_UPSELL_HASH: (state, upsellHash) => {
    state.upsell_hash = upsellHash
  },
}

export default mutations
